import { warnAndNotify } from '@execonline-inc/error-reporting.private';
import { assertNever } from '@kofno/piper';
import { Task } from 'taskarian';
import { deepLinksOptionsResourceDecoder } from './Decoders';
import { State } from './Types';
import DeepLinksOptionsStore from './index';
import { handleError } from '../../../../../../ErrorActionableReaction';
import { AppyError, callApi } from '../../../../../../Appy';
import { MissingLinkError, findLinkT } from '../../../../../../LinkyLinky';
import { Link } from '../../../../../../Resource/Types';
import ReactionComponent, { RCProps } from '../../../../../../ReactionComponent';

interface Props extends RCProps<DeepLinksOptionsStore> {}

type OptionsError = AppyError | MissingLinkError;

const handleOptionsError = (store: DeepLinksOptionsStore) => (error: OptionsError) => {
  switch (error.kind) {
    case 'missing-link-error':
      store.error('We are unable to process your request at this time');
      warnAndNotify('DeepLinksOptionsReactions', error.kind, error);
      break;
    default:
      handleError(store, error);
  }
};

const sendRequest = callApi(deepLinksOptionsResourceDecoder, {});

class DeepLinksOptionsReactions extends ReactionComponent<DeepLinksOptionsStore, State, Props> {
  tester = () => this.props.store.state;
  effect = (state: State) => {
    const { store } = this.props;
    switch (state.kind) {
      case 'waiting':
        break;
      case 'loading':
        Task.succeed<OptionsError, ReadonlyArray<Link>>(store.learningCollectionLinks)
          .andThen(findLinkT('share-urls-options'))
          .andThen(sendRequest)
          .fork(handleOptionsError(store), store.ready);
        break;
      case 'ready':
      case 'error':
        break;
      default:
        assertNever(state);
    }
  };
}

export default DeepLinksOptionsReactions;
